export const environment = {
  production: true,
  // apiUrl: 'https://uat-api-mbaza.minaloc.gov.rw/api/v1',
  apiUrl: 'https://uat-api.mbaza.gov.rw/api/v1',
};
